import { useEffect, useState } from 'react';
import { consoleLogInDev } from 'shared';
import { CoveredShift, fetchCoveredShifts } from './coveredShiftsApi';

export function useCoveredShifts(startDate: string, endDate: string, addressIds: number[]) {
    const [coveredShifts, setCoveredShifts] = useState<CoveredShift[]>([]);
    const addressKey = addressIds.join(',');

    useEffect(() => {
        if (!startDate || !endDate) {
            setCoveredShifts([]);
            return;
        }

        let active = true;
        const requestedAddressIds = addressKey ? addressKey.split(',').map(Number) : [];
        fetchCoveredShifts(startDate, endDate, requestedAddressIds)
            .then((shifts) => {
                if (active) setCoveredShifts(shifts);
            })
            .catch((error) => {
                consoleLogInDev(error);
                if (active) setCoveredShifts([]);
            });

        return () => {
            active = false;
        };
    }, [startDate, endDate, addressKey]);

    return coveredShifts;
}
